"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.txnHasTag = exports.transactionsSortFunction = exports.possiblyMatchTransfer = exports.findPossibleTransferCandidate = exports.sortTxnsByDateDifference = exports.getTxnDifferences = exports.fieldChanged = exports.areTagsEqual = exports.coasAreDifferent = exports.findTransaction = exports.quickenAmountToString = exports.replaceInArray = exports.areMatchable = exports.isAssociatedWithBankPendingTxn = exports.isMatchedToPostedTxn = exports.isUnAcceptedBankPendingTxn = exports.isUnAcceptedTxnType = exports.isBankOwnedPending = exports.isUserOwned = exports.isBankPending = exports.transactionEditsNotAllowed = exports.isInvestmentAcctTransferTxn = exports.isLoanAcctTransferTxn = exports.isUnsyncedTransferTxn = exports.isSupportedTransferTxnWithFlags = exports.txnHasUnsupportedTransfer = exports.isSupportedTransferTxn = exports.txnHasTags = exports.isUncategorizedTxn = exports.balanceSplitTxn = exports.isUnbalancedSplitTxn = exports.removeSplitLine = exports.adjustSplitLine = exports.sumSplitItems = exports.isGoalTxnInNonGoalAccount = exports.nextScheduledInstanceAfterTransaction = exports.nextScheduledInstanceAfterDate = exports.isActionableScheduledInstance = exports.isNextScheduledInstance = exports.isPendingTxn = exports.isBankDownloadedTxn = exports.isBankPendingTxn = exports.isUnacceptedScheduledTxn = exports.isAcceptedScheduledTxn = exports.isMultiCurrencyTransferTxn = exports.setReportsFlags = exports.isExistingTxn = exports.getTxnStateInfo = exports.getMatchState = exports.getSharedCurrency = void 0;
exports.isC2RTransaction = exports.shouldDisableReviewField = exports.shouldShowReviewField = exports.txnCategorySign = exports.updateMemorizePayeeValues = exports.updateNewTags = exports.getRefundState = exports.RefundState = exports.isRefundTxn = exports.isRefundVirtualTxn = exports.getCalendarTxnType = exports.deDupeTxns = exports.dateTimeFromTxn = exports.removeTxnTag = void 0;
const luxon_1 = require("luxon");
const numeral_1 = __importDefault(require("numeral"));
const immutable_1 = require("immutable");
const store_1 = __importDefault(require("store"));
const accounts_1 = require("companion-app-components/flux/accounts");
const tags_1 = require("companion-app-components/flux/tags");
const transactions_1 = require("companion-app-components/flux/transactions");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const categories_1 = require("companion-app-components/flux/categories");
const auth_1 = require("companion-app-components/flux/auth");
const accountsUtils_1 = require("companion-app-components/flux/accounts/accountsUtils");
const memoizeWithKey_1 = require("utils/memoizeWithKey");
const utils_1 = require("utils/utils");
const retrievers_1 = require("data/accounts/retrievers");
const splitsHelpers_1 = require("data/transactions/splitsHelpers");
const types_1 = require("./types");
const DATE_FORMAT = 'MM/dd/yyyy';
//-----------------------------------------------------------------------
// given an immutable list of transactions, will return the currency symbol appropriate to represent
// the group.  Either the one shared currency, or "N/A" if they differ
//
// pass in an array of transaction arrays (support for multiple transaction groups), if you only have
// one transaction list, pass in [txList]
function getSharedCurrency(txns, accounts) {
    let currency = null;
    if (txns && accounts && accounts.size > 0) {
        txns.forEach((txnList) => {
            txnList.forEach((txn) => {
                const acctRec = accounts.get(String(txn.accountId));
                if (acctRec) {
                    const tc = acctRec.get('currency');
                    if (tc !== currency) {
                        currency = !currency ? tc : 'N/A';
                    }
                }
            });
        });
    }
    return currency;
}
exports.getSharedCurrency = getSharedCurrency;
//-----------------------------------------------------------------------
// getMatchState
//
// For any transaction will return the following
//
// 'manual' - the transaction has no cpData
// 'matched' - the transaction has cpData and is matchstate is one of the MATCHED states
// 'downloaded' - the transaction has cpData, is not matched, and is not reviewed
function getMatchState(txn) {
    if (txn.cpData) {
        if (txn.matchState === 'AUTO_MATCHED' || txn.matchState === 'USER_MATCHED') {
            return 'matched';
        }
        return 'downloaded';
    }
    return 'manual';
}
exports.getMatchState = getMatchState;
/*
 * getTxnStateInfo
 *
 * This is a mapping from txn SOURCE and STATUS to an object that indicates display information for the transaction
 * object returns contains 'entry', which is either 'bank', 'matched', 'manual', or 'scheduled', and a status which is a combination of
 * transaction state and source, and is one of the following:
 * PENDING
 * CLEARED
 * UPCOMING
 * DUE (Due Today)
 * OVERDUE
 */
function getTxnStateInfo(txn) {
    const today = luxon_1.DateTime.local().startOf('day');
    const txnDay = luxon_1.DateTime.fromISO(txn.postedOn).startOf('day');
    const future = txnDay > today;
    const retObj = {
        entry: getMatchState(txn) === 'matched' ? 'matched' : 'bank',
        status: txn.state,
    };
    switch (txn.source && txn.source.trim()) {
        case 'QCS_REFRESH':
        case 'QCS_BATCH_REFRESH':
        case 'CLIENT_AGGREGATED':
            break;
        case 'QCS_REFRESH_BANK_PENDING':
        case 'QCS_BATCH_REFRESH_BANK_PENDING':
        case 'REAL_TIME':
            break;
        case 'USER_ENTERED':
            retObj.entry = getMatchState(txn) === 'matched' ? 'matched' : 'manual';
            if (txn.state === 'CLEARED' || txn.state === 'RECONCILED') {
                retObj.status = txn.state;
            }
            else {
                retObj.status = future ? 'UPCOMING' : 'PENDING';
            }
            break;
        case 'USER_OWNED_BANK_PENDING':
        case 'USER_OWNED_REAL_TIME_BANK_PENDING':
            break;
        case 'SCHEDULED_TRANSACTION_PENDING':
            retObj.status = future ? 'UPCOMING' : 'OVERDUE';
            if (txnDay.hasSame(today, 'day')) {
                retObj.status = 'DUE';
            }
            retObj.entry = retObj.entry === 'matched' ? 'matched' : 'scheduled';
            break;
        case 'SCHEDULED_TRANSACTION_UNKNOWN':
        case 'SCHEDULED_TRANSACTION': {
            if (txn.state === 'PENDING') {
                retObj.status = future ? 'UPCOMING' : 'PENDING';
            }
            else {
                retObj.status = 'CLEARED';
            }
            retObj.entry = retObj.entry === 'matched' ? 'matched' : 'scheduled';
            break;
        }
        case 'SCHEDULED_TRANSACTION_SKIPPED':
            // not applicable, this transaction should not be shown (soft deleted)
            break;
        case 'UNKNOWN':
            // should never happen - throw an event?
            retObj.entry = 'manual';
            retObj.status = future ? 'UPCOMING' : 'CLEARED';
            break;
        default:
            // this should REALLY never happen
            break;
    }
    return retObj;
}
exports.getTxnStateInfo = getTxnStateInfo;
function isExistingTxn(txn) {
    return (txn === null || txn === void 0 ? void 0 : txn.id) && txn.id !== '0';
}
exports.isExistingTxn = isExistingTxn;
function currenciesAreValidAndDifferent(strCurrency1, strCurrency2) {
    if (strCurrency1 === 'N/A' || strCurrency2 === 'N/A') {
        return false;
    }
    return strCurrency1 !== strCurrency2;
}
// -------------------------------------------------------
// setReportsFlags
function setReportsFlags(txn, value) {
    return txn && txn.set('isExcludedFromReports', Boolean(value)).set('isExcludedFromF2S', Boolean(value));
}
exports.setReportsFlags = setReportsFlags;
// -------------------------------------------------------
// isMultiCurrencyTransferTxn
function isMultiCurrencyTransferTxn(txn, state) {
    var _a;
    let isMultiCurrency = false;
    const txnCurrency = (0, retrievers_1.getCurrencyString)(txn.accountId, state);
    if (transactions_1.transactionsUtils.isTransferTxn(txn)) {
        if (transactions_1.transactionsUtils.isSplitTxn(txn) && txn.split && txn.split.items) {
            txn.split.items.forEach((item) => {
                if (item.coa.type === 'ACCOUNT') {
                    isMultiCurrency = isMultiCurrency || currenciesAreValidAndDifferent((0, retrievers_1.getCurrencyString)(item.coa.id, state), txnCurrency);
                }
            });
        }
        else {
            isMultiCurrency = currenciesAreValidAndDifferent((0, retrievers_1.getCurrencyString)((_a = txn === null || txn === void 0 ? void 0 : txn.coa) === null || _a === void 0 ? void 0 : _a.id, state), txnCurrency);
        }
    }
    return isMultiCurrency;
}
exports.isMultiCurrencyTransferTxn = isMultiCurrencyTransferTxn;
const pendingStates = [
    'QCS_REFRESH_BANK_PENDING',
    'QCS_BATCH_REFRESH_BANK_PENDING',
    'USER_OWNED_BANK_PENDING',
    'REAL_TIME',
    'USER_OWNED_REAL_TIME_BANK_PENDING',
];
const isAcceptedScheduledTxn = (txn) => txn.source && txn.source === 'SCHEDULED_TRANSACTION';
exports.isAcceptedScheduledTxn = isAcceptedScheduledTxn;
const isUnacceptedScheduledTxn = (txn) => txn.source && txn.source === 'SCHEDULED_TRANSACTION_PENDING';
exports.isUnacceptedScheduledTxn = isUnacceptedScheduledTxn;
function isBankPendingTxn(txn) {
    return pendingStates.indexOf(txn.source) >= 0;
}
exports.isBankPendingTxn = isBankPendingTxn;
function isBankDownloadedTxn(txn) {
    return txn && txn.cpData;
}
exports.isBankDownloadedTxn = isBankDownloadedTxn;
function isPendingTxn(txn) {
    return txn && txn.state === 'PENDING';
}
exports.isPendingTxn = isPendingTxn;
function isNextScheduledInstance(txn, scheduledTransactionsById) {
    if ((0, exports.isUnacceptedScheduledTxn)(txn)) {
        const model = scheduledTransactionsById.get(txn.stModelId);
        return model && luxon_1.DateTime.fromISO(model.dueOn).toFormat(DATE_FORMAT) === luxon_1.DateTime.fromISO(txn.stDueOn).toFormat(DATE_FORMAT);
    }
    return false;
}
exports.isNextScheduledInstance = isNextScheduledInstance;
function isActionableScheduledInstance(txn, scheduledTransactionsById) {
    const stateInfo = getTxnStateInfo(txn);
    const { status } = stateInfo;
    return status === 'DUE' || status === 'OVERDUE' || isNextScheduledInstance(txn, scheduledTransactionsById);
}
exports.isActionableScheduledInstance = isActionableScheduledInstance;
function sortedScheduledInstancesForAccount(accountTransactions, modelId) {
    let scheduledInstances = accountTransactions.filter((txn) => (0, exports.isUnacceptedScheduledTxn)(txn) && modelId === txn.stModelId);
    if (scheduledInstances) {
        scheduledInstances = scheduledInstances.toList();
        scheduledInstances = scheduledInstances.sort((txn1, txn2) => 
        // @ts-expect-error - FIXME: type issue ts(2363)
        luxon_1.DateTime.fromISO(txn1.postedOn) - luxon_1.DateTime.fromISO(txn2.postedOn));
    }
    return scheduledInstances;
}
function internalNextScheduledInstanceAfterDate(date, accountTransactions, modelId) {
    const scheduledInstances = sortedScheduledInstancesForAccount(accountTransactions, modelId);
    const index = scheduledInstances.findIndex((x) => luxon_1.DateTime.fromISO(x.postedOn) > luxon_1.DateTime.fromISO(date));
    if (index !== -1) {
        return scheduledInstances.get(index);
    }
    return null;
}
function nextScheduledInstanceAfterDate(date, accountTransactions, modelId) {
    const key = `${luxon_1.DateTime.fromISO(date).toFormat('yyyy-MM-dd')}-${modelId}-${accountTransactions.hashCode()}`;
    return (0, memoizeWithKey_1.memoizeWithKey)('nextScheduled', () => internalNextScheduledInstanceAfterDate(date, accountTransactions, modelId), key, 50);
    /* TODO: Keeping this commented piece of code after TS migration
    const index = memoCache.findIndex((x) => x.key === key);
    if (index !== -1) return memoCache[index].value;
  
    const ret = internalNextScheduledInstanceAfterDate(date, accountTransactions, modelId);
    memoCache.push({key, value: ret});
    if (memoCache.size > 50) {
      memoCache = memoCache.slice(1);
    }
    return ret;
     */
}
exports.nextScheduledInstanceAfterDate = nextScheduledInstanceAfterDate;
function nextScheduledInstanceAfterTransaction(txn, accountTransactions) {
    const scheduledInstances = sortedScheduledInstancesForAccount(accountTransactions, txn.stModelId);
    const index = scheduledInstances.findIndex((x) => x.id === txn.id);
    if (index !== -1 && index + 1 < scheduledInstances.size) {
        return scheduledInstances.get(index + 1);
    }
    return null;
}
exports.nextScheduledInstanceAfterTransaction = nextScheduledInstanceAfterTransaction;
const isGoalTxnInNonGoalAccount = (txn, goalAccountIds) => txn.coa && txn.coa.type === 'ACCOUNT' && goalAccountIds.contains(txn.coa.id) && !goalAccountIds.contains(txn.accountId);
exports.isGoalTxnInNonGoalAccount = isGoalTxnInNonGoalAccount;
// # ================================================================ #
// # - - -            Split logic/functions                     - - - #
// # ================================================================ #
function sumSplitItems(split) {
    let sum = 0;
    if (split && split.items) {
        split.items.forEach((item) => {
            sum += Number(item.amount);
        });
    }
    return sum;
}
exports.sumSplitItems = sumSplitItems;
// ----------------
// adjustSplitLine
// ----------------
// given a txn and the index of the splitItem just edited, perform the balancing
// and return the updated split
//
// expects an immutable split
function adjustSplitLine(txn, index) {
    assert(index !== undefined, 'FORGOT TO PASS IN AN INDEX');
    let newSplit = txn.split;
    const { items } = newSplit;
    const diff = Number((Number(txn.amount) - sumSplitItems(newSplit)).toFixed(2));
    function adjustAmountAtIndex(adjustIndex) {
        const otherItem = items.get(adjustIndex);
        const newAmount = Number(Number(otherItem.amount + diff).toFixed(2));
        newSplit = newSplit.setIn(['items', adjustIndex, 'amount'], newAmount);
    }
    if (items.size === 2) {
        // 2 items
        const otherIndex = index === 0 ? 1 : 0;
        adjustAmountAtIndex(otherIndex);
    }
    else {
        // multiple items
        // look for uncategorized item to change (that isn't the item you just edited)
        const uncatIndex = items.findIndex((item, currentIndex) => currentIndex !== index && item.coa.type === 'UNCATEGORIZED');
        if (uncatIndex >= 0) {
            adjustAmountAtIndex(uncatIndex);
        }
        else {
            // add uncat item with the difference
            newSplit = newSplit.set('items', items.push(transactions_1.transactionsTypes.mkSplitItem({
                amount: diff,
                coa: { type: 'UNCATEGORIZED', id: '0' },
            })));
        }
    }
    return newSplit;
}
exports.adjustSplitLine = adjustSplitLine;
// ----------------
// removeSplitLine
// ----------------
// given a txn and the index of the splitItem to remove, perform the balancing
// and return the updated split (and category)
//
// expects an immutable split
function removeSplitLine(txn, index) {
    assert(index !== undefined, 'FORGOT TO PASS IN AN INDEX');
    let newSplit = txn.split;
    const { items } = newSplit;
    const itemToRemove = items.get(index);
    // exit early if deleting a zero amount
    if (itemToRemove.amount === 0) {
        return newSplit.deleteIn(['items', index]);
    }
    function adjustAmountAtIndex(adjustIndex) {
        const otherItem = items.get(adjustIndex);
        const newAmount = Number(Number(otherItem.amount + itemToRemove.amount).toFixed(2));
        newSplit = newSplit.setIn(['items', adjustIndex, 'amount'], newAmount);
    }
    // push the amount somewhere else
    // look for uncategorized item to change (that isn't the item to delete)
    const uncatIndex = items.findIndex((item, currentIndex) => currentIndex !== index && item.coa.type === 'UNCATEGORIZED');
    if (uncatIndex !== -1) {
        // uncat found
        adjustAmountAtIndex(uncatIndex);
    }
    else {
        // look for same category item (that isn't the item to delete)
        const sameCatIndex = items.findIndex((item, currentIndex) => currentIndex !== index && item.coa.type === itemToRemove.coa.type && item.coa.id === itemToRemove.coa.id);
        if (sameCatIndex !== -1) {
            // same cat found
            adjustAmountAtIndex(sameCatIndex);
        }
        else {
            // push to the top
            const defaultIndex = index === 0 ? 1 : 0;
            adjustAmountAtIndex(defaultIndex);
        }
    }
    newSplit = newSplit.deleteIn(['items', index]);
    return newSplit;
}
exports.removeSplitLine = removeSplitLine;
// made to work with JS objects and immutables
function isUnbalancedSplitTxn(txn) {
    if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
        return Number(txn.amount).toFixed(2) !== sumSplitItems(txn.split).toFixed(2);
    }
    return false;
}
exports.isUnbalancedSplitTxn = isUnbalancedSplitTxn;
// made to work with JS objects and immutables
function balanceSplitTxn(txn) {
    let newTxn = txn;
    if (isUnbalancedSplitTxn(txn)) {
        const isImmutable = txn.split.items.size !== undefined;
        // set toFixed and then back to number to avoid fixed precision calculation error
        const diff = Number((Number(txn.amount) - sumSplitItems(txn.split)).toFixed(2));
        const uncatItem = txn.split.items.findIndex((item) => item.coa.type === 'UNCATEGORIZED');
        // if there is an uncategorized row already, add the difference to it
        if (uncatItem >= 0) {
            const newAmount = Number((Number(isImmutable ? txn.split.items.get(uncatItem).amount : txn.split.items[uncatItem].amount) + diff).toFixed(2));
            if (isImmutable) {
                if (txn.setIn) {
                    // txn object is immutable
                    newTxn = txn.setIn(['split', 'items', uncatItem, 'amount'], newAmount);
                }
                else {
                    // txn object javascript but split immutable
                    newTxn.split = txn.split.setIn(['items', uncatItem, 'amount'], newAmount);
                }
            }
            else {
                newTxn.split.items[uncatItem].amount = newAmount;
            }
            // otherwise create a new uncategorized row
        }
        else if (isImmutable) {
            const items = txn.split.items.push(transactions_1.transactionsTypes.mkSplitItem({
                amount: diff,
                coa: { type: 'UNCATEGORIZED', id: '0' },
            }));
            if (txn.setIn) {
                // txn object is immutable
                newTxn = txn.setIn(['split', 'items'], items);
            }
            else {
                // txn object javascript but split immutable
                newTxn.split = txn.split.set('items', items);
            }
        }
        else {
            newTxn.split.items.push({ coa: { type: 'UNCATEGORIZED', id: '0' }, amount: diff });
        }
    }
    return newTxn;
}
exports.balanceSplitTxn = balanceSplitTxn;
function isUncategorizedTxn(txn) {
    return !transactions_1.transactionsUtils.isSplitTxn(txn) && (!txn.coa || txn.coa.type === 'UNCATEGORIZED');
}
exports.isUncategorizedTxn = isUncategorizedTxn;
function txnHasTags(txn) {
    return Boolean(txn.tags && txn.tags.size > 0);
}
exports.txnHasTags = txnHasTags;
function isSupportedTransferTxn(txn, state) {
    var _a;
    if (transactions_1.transactionsUtils.isSplitTxn(txn) && ((_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items)) {
        return Boolean(txn.split.items.find((item) => chart_of_accounts_1.chartOfAccountsUtils.isSupportedTransferCoa(item.coa, state)));
    }
    return chart_of_accounts_1.chartOfAccountsUtils.isSupportedTransferCoa(txn.coa, state);
}
exports.isSupportedTransferTxn = isSupportedTransferTxn;
function txnHasUnsupportedTransfer(txn, featureFlags, state) {
    var _a;
    if (!transactions_1.transactionsUtils.isTransferTxn(txn))
        return false;
    const hideLoanTransactions = featureFlags.get('hideLoanTransactions');
    const hideConnectedLoanTransactions = featureFlags.get('hideConnectedLoanTransactions');
    if (transactions_1.transactionsUtils.isSplitTxn(txn) && ((_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items)) {
        return Boolean(
        // @ts-expect-error - FIXME: type issue with find(). No overload matches this call
        txn.split.items.find((item) => item.coa.type === 'ACCOUNT' &&
            accounts_1.accountsUtils.transactionsNotSupportedForAccountId(item.coa.id, hideLoanTransactions, hideConnectedLoanTransactions, state)));
    }
    return ((txn === null || txn === void 0 ? void 0 : txn.coa) &&
        accounts_1.accountsUtils.transactionsNotSupportedForAccountId(txn.coa.id, hideLoanTransactions, hideConnectedLoanTransactions, state));
}
exports.txnHasUnsupportedTransfer = txnHasUnsupportedTransfer;
function isSupportedTransferTxnWithFlags(txn, featureFlags, state) {
    if (!transactions_1.transactionsUtils.isTransferTxn(txn))
        return false;
    return !txnHasUnsupportedTransfer(txn, featureFlags, state);
}
exports.isSupportedTransferTxnWithFlags = isSupportedTransferTxnWithFlags;
function isUnsyncedTransferTxn(txn, state) {
    var _a;
    if (transactions_1.transactionsUtils.isSplitTxn(txn) && ((_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items)) {
        return Boolean(txn.split.items.find((item) => chart_of_accounts_1.chartOfAccountsUtils.isUnsyncedTransferCoa(item.coa, state)));
    }
    return chart_of_accounts_1.chartOfAccountsUtils.isUnsyncedTransferCoa(txn.coa, state);
}
exports.isUnsyncedTransferTxn = isUnsyncedTransferTxn;
function isLoanAcctTransferTxn(txn, state) {
    var _a;
    if (transactions_1.transactionsUtils.isSplitTxn(txn) && ((_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items)) {
        return Boolean(txn.split.items.find((item) => chart_of_accounts_1.chartOfAccountsUtils.isLoanAcctTransferCoa(item.coa, state)));
    }
    return chart_of_accounts_1.chartOfAccountsUtils.isLoanAcctTransferCoa(txn.coa, state);
}
exports.isLoanAcctTransferTxn = isLoanAcctTransferTxn;
function isInvestmentAcctTransferTxn(txn, state) {
    var _a;
    if (transactions_1.transactionsUtils.isSplitTxn(txn) && ((_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items)) {
        return Boolean(txn.split.items.find((item) => chart_of_accounts_1.chartOfAccountsUtils.isInvestmentAcctTransferCoa(item.coa, state)));
    }
    return chart_of_accounts_1.chartOfAccountsUtils.isInvestmentAcctTransferCoa(txn.coa, state);
}
exports.isInvestmentAcctTransferTxn = isInvestmentAcctTransferTxn;
// -------------------------------------------------------
// Returns null if edits are allowed, otherwise returns
// a reason code
// UNSUPPORTED_SCHED_TRANSFER
// BILLPAY_TRANSACTION
//
function transactionEditsNotAllowed(txn, state) {
    // if this is a transfer, and a scheduled instance make sure it is a legit transfer
    if (transactions_1.transactionsUtils.isTransferTxn(txn) && (0, exports.isUnacceptedScheduledTxn)(txn) && !isSupportedTransferTxn(txn, state)) {
        return 'UNSUPPORTED_SCHED_TRANSFER';
    }
    if (txn.paymentProvider === 'OFX') {
        return 'BILLPAY_TRANSACTION';
    }
    return null;
}
exports.transactionEditsNotAllowed = transactionEditsNotAllowed;
function isBankPending(txn) {
    return isBankPendingTxn(txn); // /.+_BANK_PENDING$/.test(txn.source);
}
exports.isBankPending = isBankPending;
function isUserOwned(txn) {
    // return (txn.source.indexOf('USER_') === 0 || txn.source.indexOf('SCHEDULED_TRANSACTION') === 0);
    return /^USER_.+/.test(txn.source) || /^SCHEDULED_TRANSACTIO.+/.test(txn.source);
}
exports.isUserOwned = isUserOwned;
function isBankOwnedPending(txn) {
    return txn.source && isBankPendingTxn(txn) && !isUserOwned(txn);
}
exports.isBankOwnedPending = isBankOwnedPending;
// check is SCHEDULED and BANK_PENDING txn
function isUnAcceptedTxnType(txn) {
    return (0, exports.isUnacceptedScheduledTxn)(txn) || isBankOwnedPending(txn);
}
exports.isUnAcceptedTxnType = isUnAcceptedTxnType;
function isUnAcceptedBankPendingTxn(account, txn) {
    return account.isBankPendingTxnsExcluded && isBankOwnedPending(txn);
}
exports.isUnAcceptedBankPendingTxn = isUnAcceptedBankPendingTxn;
// A "match" is one which has a user-owned txn matched to a posted-txn. This is specifically excluding a
// transactions that are user-owned and matched to bank-pending txn.
function isMatchedToPostedTxn(txn) {
    var _a;
    return isUserOwned(txn) && txn.cpData && txn.cpData.id && ((_a = txn.matchedTxn) === null || _a === void 0 ? void 0 : _a.id);
}
exports.isMatchedToPostedTxn = isMatchedToPostedTxn;
function isAssociatedWithBankPendingTxn(txn) {
    return txn.cpData && (txn.cpData.pendingId || txn.cpData.cpPendingId); // cpPendingId will become pendingId, backward compatible
}
exports.isAssociatedWithBankPendingTxn = isAssociatedWithBankPendingTxn;
function areMatchable(txn1, txn2) {
    let srcTxn;
    let dstTxn;
    if (isUserOwned(txn1)) {
        if (isUserOwned(txn2)) {
            return false; // one must be non user-owned
        }
        srcTxn = txn2;
        dstTxn = txn1;
    }
    else {
        if (!isUserOwned(txn2)) {
            return false; // one must be user-owned
        }
        srcTxn = txn1;
        dstTxn = txn2;
    }
    if (srcTxn.accountId !== dstTxn.accountId) {
        return false; // they must belong to the same account
    }
    if (isMatchedToPostedTxn(dstTxn)) {
        return false; // already matched to posted-txn (need to first unmatch before re-matching)
    }
    if (isBankPending(srcTxn) && isAssociatedWithBankPendingTxn(dstTxn)) {
        return false; // destination txn is already associated with a bank-pending txn
    }
    return true;
}
exports.areMatchable = areMatchable;
// used to update txns in preprocess (allTxnsToUpdate/allTxnsToCreate)
function replaceInArray(txnsArray, txnToReplace) {
    const foundIndex = txnsArray.findIndex((txn) => (txn === null || txn === void 0 ? void 0 : txn.id) === (txnToReplace === null || txnToReplace === void 0 ? void 0 : txnToReplace.id) || (txn === null || txn === void 0 ? void 0 : txn.clientId) === (txnToReplace === null || txnToReplace === void 0 ? void 0 : txnToReplace.clientId));
    const found = foundIndex > -1;
    if (found) {
        txnsArray.splice(foundIndex, 1, txnToReplace);
    }
    return found;
}
exports.replaceInArray = replaceInArray;
// Given a user provided amount, proposedSign is either 1 or -1
function quickenAmountToString(amountStr, proposedSign = 1) {
    // this just safety checks the value to ensure it is either 1 or -1
    let sign = (proposedSign / proposedSign || 1) * Math.sign(proposedSign) || 1;
    if (String(amountStr).charAt(0) === '+') {
        sign = 1;
    }
    if (String(amountStr).charAt(0) === '-') {
        sign = -1;
    }
    return (0, numeral_1.default)(Math.abs(Number(amountStr)) * sign).format('0.00');
}
exports.quickenAmountToString = quickenAmountToString;
//-------------------------------------------------------
// findTransaction
//
function findTransaction(txnsByAccountId, txnId, accountId) {
    if (accountId) {
        const acctTxns = txnsByAccountId === null || txnsByAccountId === void 0 ? void 0 : txnsByAccountId.get(accountId);
        if (acctTxns) {
            const foundTxn = acctTxns.get(txnId);
            if (foundTxn)
                return foundTxn;
        }
    }
    // slow way
    let ret = null;
    txnsByAccountId === null || txnsByAccountId === void 0 ? void 0 : txnsByAccountId.some((txnList) => {
        const foundTxn = txnList.get(txnId);
        if (foundTxn) {
            ret = foundTxn;
            return true;
        }
        return false;
    });
    return ret;
}
exports.findTransaction = findTransaction;
function coasAreDifferent(coa1, coa2) {
    if (!coa1 && !coa2) {
        return false;
    }
    if (!coa1 || !coa2) {
        return true;
    }
    return coa1.type !== coa2.type || coa1.id !== coa2.id;
}
exports.coasAreDifferent = coasAreDifferent;
const matchTagIds = (tag1, tag2) => (Number(tag1.id) > Number(tag2.id) ? 1 : -1);
const matchSplitCoaIds = (split1, split2) => { var _a, _b; return (Number((_a = split1 === null || split1 === void 0 ? void 0 : split1.coa) === null || _a === void 0 ? void 0 : _a.id) > Number((_b = split2 === null || split2 === void 0 ? void 0 : split2.coa) === null || _b === void 0 ? void 0 : _b.id) ? 1 : -1); };
const splitStringVal = (item) => `${item.coa.id}-${Number(item.amount).toFixed(2)}-${item.memo}-${item.tags ? item.tags.length : 'none'}`;
const reducerSplitSum = (total, item) => `${total}-${splitStringVal(item)}`;
function areTagsEqual(tags1, tags2) {
    if (!tags1 && !tags2) {
        return true;
    }
    if (!tags1 || !tags2) {
        return false;
    }
    const sum1 = tags1.sort(matchTagIds).reduce((total, num) => `${total}-${num.id}`, '');
    const sum2 = tags2.sort(matchTagIds).reduce((total, num) => `${total}-${num.id}`, '');
    return sum1 === sum2;
}
exports.areTagsEqual = areTagsEqual;
function fieldChanged(txn, txnPrev, field) {
    var _a, _b;
    // this is checking if one or the other is null, however, we have to do a bit more
    // for splits since even though .split may not be null, it can still be a non-split if
    // there are no items
    // should not be called with either value being null
    if (!txn || !txnPrev) {
        return false;
    }
    if (!txn[field] || !txnPrev[field]) {
        return field === 'split'
            ? transactions_1.transactionsUtils.isSplitTxn(txn) !== transactions_1.transactionsUtils.isSplitTxn(txnPrev)
            : Boolean(txn[field]) !== Boolean(txnPrev[field]);
    }
    switch (field) {
        case 'amount': {
            return Number(txnPrev.amount) !== Number(txn.amount);
        }
        case 'postedOn': {
            return txnPrev.postedOn !== txn.postedOn;
        }
        case 'coa': {
            return coasAreDifferent(txnPrev.coa, txn.coa); // ((txnPrev.coa.id !== txn.coa.id) || (txnPrev.coa.type !== txn.coa.type));
        }
        case 'check': {
            return txnPrev.check && txn.check && txnPrev.check.number !== txn.check.number;
        }
        case 'attachments': {
            const sum1 = txn[field].sort((a, b) => (a > b ? 1 : -1)).reduce((total, num) => `${total}-${num}`, '');
            const sum2 = txnPrev[field].sort((a, b) => (a > b ? 1 : -1)).reduce((total, num) => `${total}-${num}`, '');
            return sum1 !== sum2;
        }
        case 'tags': {
            return !areTagsEqual(txn[field], txnPrev[field]);
        }
        case 'split': {
            if (transactions_1.transactionsUtils.isSplitTxn(txn) !== transactions_1.transactionsUtils.isSplitTxn(txnPrev)) {
                return true;
            }
            // @ts-expect-error - FIXME: This expression is not callable
            const sum1 = ((_a = txnPrev === null || txnPrev === void 0 ? void 0 : txnPrev.split) === null || _a === void 0 ? void 0 : _a.items) && txnPrev.split.items.sort(matchSplitCoaIds).reduce(reducerSplitSum, '');
            // @ts-expect-error - FIXME: reduce (This expression is not callable)
            const sum2 = ((_b = txn === null || txn === void 0 ? void 0 : txn.split) === null || _b === void 0 ? void 0 : _b.items) && txn.split.items.sort(matchSplitCoaIds).reduce(reducerSplitSum, '');
            return sum1 !== sum2;
        }
        default:
            if (txnPrev) {
                return txn[field] !== txnPrev[field];
            }
    }
    return false;
}
exports.fieldChanged = fieldChanged;
function getTxnDifferences(txn, txnPrev) {
    const fields = [
        'accountId',
        'postedOn',
        'payee',
        'coa',
        'amount',
        'userFlag',
        'memo',
        'state',
        'isReviewed',
        'tags',
        'check',
        'attachments',
        'split',
        'isExcludedFromReports',
        'isExcludedFromF2S',
        'isDeleted',
    ];
    const changed = [];
    fields.forEach((field) => {
        if (fieldChanged(txn, txnPrev, field)) {
            changed.push(field);
        }
    });
    return changed;
}
exports.getTxnDifferences = getTxnDifferences;
// The code below is used to find possible transfers for new transactions being inserted.  When a new
// transfer transaction is entered, we look in the transfer account for a possible transaction match that
// may already be there, and offer the user to match to that transaction rather than create a dup
function isPossibleMatch(txn, postedOn, amount, days = 31) {
    const diff = luxon_1.DateTime.fromISO(postedOn).diff(luxon_1.DateTime.fromISO(txn.postedOn), 'days').days;
    return (!transactions_1.transactionsUtils.isSplitTxn(txn) &&
        !transactions_1.transactionsUtils.isTransferTxn(txn) &&
        Math.abs(diff) <= days &&
        Number(amount) === Number(txn.amount));
}
function sortTxnsByDateDifference(txns, referenceDate) {
    const referenceDateTime = luxon_1.DateTime.fromISO(referenceDate);
    return txns.sort((a, b) => {
        const diff1 = Math.abs(luxon_1.DateTime.fromISO(a.postedOn).diff(referenceDateTime, 'days').days); // Math.abs(moment(a.postedOn).diff(moment(referenceDate), 'days'));
        const diff2 = Math.abs(luxon_1.DateTime.fromISO(b.postedOn).diff(referenceDateTime, 'days').days);
        if (diff1 === diff2) {
            return 0;
        }
        if (diff1 > diff2) {
            return 1;
        }
        return -1;
    });
}
exports.sortTxnsByDateDifference = sortTxnsByDateDifference;
function findPossibleTransferCandidate(accountId, postedOn, amount, txnsByAccountId, days) {
    const acctTxns = txnsByAccountId.get(accountId) || (0, immutable_1.List)([]);
    const txns = acctTxns.filter((txn) => isPossibleMatch(txn, postedOn, amount, days)).toList();
    if (txns) {
        return sortTxnsByDateDifference(txns, postedOn).first();
    }
    return null;
}
exports.findPossibleTransferCandidate = findPossibleTransferCandidate;
function possiblyMatchTransfer(_txn, txnsByAccountId) {
    var _a;
    let txn = _txn;
    if (!transactions_1.transactionsUtils.isSplitTxn(txn) &&
        !transactions_1.transactionsUtils.isTransferTxn(txn) &&
        txn.coa &&
        chart_of_accounts_1.chartOfAccountsUtils.isL1TransferCoa(txn.coa)) {
        let matches = (0, immutable_1.List)();
        txnsByAccountId.forEach((acctTxns, acctId) => {
            if (acctId !== txn.accountId) {
                // check if there is a matching transaction and score it
                const match = findPossibleTransferCandidate(acctId, txn.postedOn, -txn.amount, txnsByAccountId, 5);
                if (match) {
                    matches = matches.push(match);
                }
            }
        });
        if (matches.size > 0) {
            const bestMatch = sortTxnsByDateDifference(matches, txn.postedOn).first();
            txn = txn.set('coa', { type: 'ACCOUNT', id: (_a = bestMatch === null || bestMatch === void 0 ? void 0 : bestMatch.accountId) !== null && _a !== void 0 ? _a : '' });
        }
    }
    return txn;
}
exports.possiblyMatchTransfer = possiblyMatchTransfer;
function transactionsSortFunction(txn1, txn2) {
    var _a, _b;
    // note, these are day boundary values constructed by convertToUnixDay
    // @ts-expect-error - FIXME: type issue ts(2363)
    let cmpValue = luxon_1.DateTime.fromISO(txn1.postedOn) - luxon_1.DateTime.fromISO(txn2.postedOn);
    if (cmpValue === 0) {
        // we sort balance adjustments to the top
        if ((txn1.coa && txn1.coa.type === 'BALANCE_ADJUSTMENT') || ((_a = txn2.id) === null || _a === void 0 ? void 0 : _a.substr(0, 3)) === 'new') {
            cmpValue = -1;
        }
        else if ((txn2.coa && txn2.coa.type === 'BALANCE_ADJUSTMENT') || ((_b = txn1.id) === null || _b === void 0 ? void 0 : _b.substr(0, 3)) === 'new') {
            cmpValue = 1;
        }
        else {
            const va = Number(txn1.id) || Number(txn2.id) + 1;
            const vb = Number(txn2.id) || Number(txn1.id) + 1;
            cmpValue = va - vb;
        }
    }
    return cmpValue;
}
exports.transactionsSortFunction = transactionsSortFunction;
// TODO Need UNIT TESTS for this potentially data damaging functionality
// determine if this transaction has the given tag id in it
function txnHasTag(txn, tag) {
    var _a;
    if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
        const ret = ((_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items) && txn.split.items.find((item) => item.tags && item.tags.find((rec) => rec.id === tag.id));
        return Boolean(ret);
    }
    // @ts-expect-error - FIXME: This expression is not callable
    return txn.tags && txn.tags.filter((tagItem) => tagItem.id === tag.id).size > 0;
}
exports.txnHasTag = txnHasTag;
// remove the reference to the given tag id from the transaction
function removeTxnTag(txn, tag) {
    var _a;
    if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
        const removeTagFromItem = (item) => {
            if (!(item === null || item === void 0 ? void 0 : item.tags)) {
                return item;
            }
            const updatedTags = item.tags.filter((tagItem) => tagItem.id !== tag.id);
            return item.set ? item.set('tags', updatedTags) : Object.assign(Object.assign({}, item), { tags: updatedTags });
        };
        return txn.setIn(['split', 'items'], ((_a = txn === null || txn === void 0 ? void 0 : txn.split) === null || _a === void 0 ? void 0 : _a.items) && txn.split.items.map((item) => removeTagFromItem(item)));
    }
    // @ts-expect-error - FIXME: This expression is not callable
    return txn.set('tags', txn.tags && txn.tags.filter((tagItem) => tagItem.id !== tag.id));
}
exports.removeTxnTag = removeTxnTag;
// simple protected dateTime check
function dateTimeFromTxn(txn) {
    return ((txn.postedOn && luxon_1.DateTime.fromISO(txn.postedOn)) ||
        (txn.stDueOn && luxon_1.DateTime.fromISO(txn.stDueOn)) ||
        luxon_1.DateTime.local()).startOf('day');
}
exports.dateTimeFromTxn = dateTimeFromTxn;
/*
 * deDupeTxns
 *
 * Given a immutable list of transactions, will identify duplicates by txnId, and remove them so the returned list
 * contains only unique transactions
 */
function deDupeTxns(txns) {
    let exclusionSet = (0, immutable_1.Set)();
    return txns.filter((txn) => {
        const dup = exclusionSet.includes(txn.id);
        exclusionSet = exclusionSet.add(txn.id);
        return !dup;
    });
}
exports.deDupeTxns = deDupeTxns;
/*
 * CalendarTxnType can be [income | expense | overdue | normal | more]
 */
const getCalendarTxnType = (txn, incomeCOAs) => {
    const txnState = getTxnStateInfo(txn);
    const isIncome = transactions_1.transactionsUtils.isIncomeFromTxn(txn, incomeCOAs);
    let type = transactions_1.transactionsTypes.calTxnLabelTypes.normal;
    if (txnState.status === 'OVERDUE') {
        type = transactions_1.transactionsTypes.calTxnLabelTypes.overdue;
    }
    if (txnState.status !== 'OVERDUE' && txnState.entry === 'scheduled') {
        type = isIncome ? transactions_1.transactionsTypes.calTxnLabelTypes.income : transactions_1.transactionsTypes.calTxnLabelTypes.expense;
        if ((0, exports.isAcceptedScheduledTxn)(txn)) {
            type = transactions_1.transactionsTypes.calTxnLabelTypes.normal; // Entered txn
        }
    }
    return type;
};
exports.getCalendarTxnType = getCalendarTxnType;
const isRefundVirtualTxn = (txn) => (txn === null || txn === void 0 ? void 0 : txn.subtype) === 'REFUND_SHADOW_TXN' || ((txn === null || txn === void 0 ? void 0 : txn.subtype) === 'REFUND' && (txn === null || txn === void 0 ? void 0 : txn.state) === 'PENDING');
exports.isRefundVirtualTxn = isRefundVirtualTxn;
const isRefundTxn = (txn) => (txn === null || txn === void 0 ? void 0 : txn.subtype) === 'REFUND_SHADOW_TXN' || (txn === null || txn === void 0 ? void 0 : txn.subtype) === 'REFUND';
exports.isRefundTxn = isRefundTxn;
exports.RefundState = Object.freeze({
    EXPECTED: 'EXPECTED',
    OVERDUE: 'OVERDUE',
    COMPLETE: 'COMPLETE',
    SHADOW: 'SHADOW',
    NONREFUND: 'NONREFUND',
});
const getRefundState = (transaction) => {
    let refundState;
    switch (transaction.subtype) {
        case 'REFUND':
            if (transaction.state === 'PENDING') {
                const dateNow = luxon_1.DateTime.local().startOf('day');
                const dateRefund = luxon_1.DateTime.fromISO(transaction.postedOn);
                if (dateRefund < dateNow) {
                    refundState = exports.RefundState.OVERDUE;
                }
                else {
                    refundState = exports.RefundState.EXPECTED;
                }
            }
            else {
                refundState = exports.RefundState.COMPLETE;
            }
            break;
        case 'REFUND_SHADOW_TXN':
            refundState = exports.RefundState.SHADOW;
            break;
        default:
            refundState = exports.RefundState.NONREFUND;
    }
    return refundState;
};
exports.getRefundState = getRefundState;
// -------------------------------------------------------
// updateNewTags
//
// takes an immutable transaction, and checks for tags with ID="0" and tries to
// find a tag that is suitable with a real ID.  Returns an immutable transaction
// with updates if they were needed
function updateNewTags(txn, dropPlaceholders = false, state = store_1.default.getState()) {
    var _a;
    let retTxn = txn;
    if (txn.tags) {
        const visited = [];
        const newTags = txn.tags
            // @ts-expect-error - FIXME: This expression is not callable
            .filter((tag) => {
            // remove dupes or empty entries
            if (tag) {
                const alreadyHas = visited.find((x) => x.id === tag.id && (x.id !== '0' || x.name === tag.name));
                if (!alreadyHas) {
                    visited.push(tag);
                    return true;
                }
            }
            return false;
        })
            .map((tag) => {
            // find current tag
            if ((0, utils_1.noNaN)(tag === null || tag === void 0 ? void 0 : tag.id) === 0) {
                const ret = tags_1.tagsSelectors.getTagByName(state, tag.name);
                return ret && ret.id ? { id: ret.id } : tag;
            }
            return tag;
        });
        retTxn = txn.set('tags', newTags.filter((tagItem) => tagItem !== null && (!dropPlaceholders || (0, utils_1.noNaN)(tagItem === null || tagItem === void 0 ? void 0 : tagItem.id) !== 0)));
    }
    if (transactions_1.transactionsUtils.isSplitTxn(retTxn)) {
        const newItems = ((_a = retTxn === null || retTxn === void 0 ? void 0 : retTxn.split) === null || _a === void 0 ? void 0 : _a.items) &&
            retTxn.split.items.map((item) => {
                if (item === null || item === void 0 ? void 0 : item.tags) {
                    const newSplitTags = item.tags.map((tag) => {
                        if ((0, utils_1.noNaN)(tag.id) === 0) {
                            const ret = tags_1.tagsSelectors.getTagByName(store_1.default.getState(), tag.name);
                            if (ret && ret.id) {
                                return { id: ret.id };
                            }
                            return dropPlaceholders ? null : tag;
                        }
                        return tag;
                    });
                    if (item.set && typeof item.set === 'function') {
                        // immutable object
                        return ((item === null || item === void 0 ? void 0 : item.set('tags', 
                        // @ts-expect-error - FIXME: This expression is not callable
                        newSplitTags.filter((splitTag) => splitTag !== null && (!dropPlaceholders || (0, utils_1.noNaN)(splitTag.id) !== 0)))) || item);
                    }
                    const newItem = item;
                    // @ts-expect-error - FIXME: Cannot assign to tags because it is a read-only property ts(2540)
                    newItem.tags = newSplitTags.filter((splitTag) => splitTag !== null && (!dropPlaceholders || (0, utils_1.noNaN)(splitTag.id) !== 0)) || item;
                    return newItem;
                }
                return item;
            });
        retTxn = retTxn.setIn(['split', 'items'], newItems);
    }
    return retTxn;
}
exports.updateNewTags = updateNewTags;
/**
 * memorizedPayee list of memorized payees & payees list from txns
 * @param {*} txn
 * @param {*} memorizedPayee
 * @returns txn with memorized payee values
 */
function updateMemorizePayeeValues(txn, memorizedPayee) {
    let retTxn = txn;
    // downloaded txn amount is not changed
    if (!retTxn.get('cpData') && !memorizedPayee.isAmountBasedRule && memorizedPayee.isMemorizedPayee) {
        retTxn = retTxn.set('amount', memorizedPayee.txn.amount);
    }
    if (transactions_1.transactionsUtils.isSplitTxn(memorizedPayee.txn)) {
        // We need to null out the id's for the split items
        /* eslint-disable arrow-body-style */
        let newSplitItems = memorizedPayee.txn.split.items.map((item) => {
            return Object.assign(Object.assign({}, item.toJS()), { id: null });
        });
        // add adjustment amount with split for downloaded txn
        if (retTxn.get('cpData')) {
            const adjAmount = txn.get('amount') - (0, splitsHelpers_1.sumSplitRows)(newSplitItems);
            const newRow = {
                memo: '',
                tags: [],
                coa: { type: chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.UNCATEGORIZED, id: '0' },
                amount: (0, numeral_1.default)(adjAmount).format('0.00'),
            };
            newSplitItems = newSplitItems.push(newRow);
        }
        else {
            retTxn = retTxn.set('amount', memorizedPayee.txn.amount);
        }
        retTxn = retTxn.set('split', transactions_1.transactionsTransformers.mkSplit({ items: newSplitItems }));
        retTxn = retTxn.set('coa', null);
    }
    else {
        retTxn = retTxn.set('coa', memorizedPayee.txn.coa);
        retTxn = retTxn.set('split', null);
    }
    retTxn = retTxn.set('tags', memorizedPayee.isMemorizedPayee ? memorizedPayee.txn.tags : null);
    retTxn = retTxn.set('memo', memorizedPayee.isMemorizedPayee ? memorizedPayee.txn.memo : null);
    if (memorizedPayee.isMemorizedPayee) {
        retTxn = retTxn.set('state', memorizedPayee.markAsCleared ? types_1.TransactionStatus.CLEARED : types_1.TransactionStatus.PENDING);
    }
    return retTxn;
}
exports.updateMemorizePayeeValues = updateMemorizePayeeValues;
/**
 * txnCategorySign
 * @param {*} txn
 * @returns
 */
function txnCategorySign(txn) {
    if (transactions_1.transactionsUtils.isSplitTxn(txn)) {
        return 1;
    }
    const isIncomeCat = txn.coa ? categories_1.categoriesSelectors.isIncomeCat(null, txn.coa.id) : false;
    return isIncomeCat ? 1 : -1;
}
exports.txnCategorySign = txnCategorySign;
const shouldShowReviewField = (accountId) => {
    const account = accounts_1.accountsSelectors.getAccountById(store_1.default === null || store_1.default === void 0 ? void 0 : store_1.default.getState(), accountId);
    const isQWinDataset = auth_1.authSelectors.getIsWinDataset(store_1.default.getState());
    return isQWinDataset ? account && !(0, accountsUtils_1.isAccountDisconnected)(account) : true;
};
exports.shouldShowReviewField = shouldShowReviewField;
const shouldDisableReviewField = (transaction) => {
    const isQWinDataset = auth_1.authSelectors.getIsWinDataset(store_1.default.getState());
    return isQWinDataset ? transaction.isReviewed : false;
};
exports.shouldDisableReviewField = shouldDisableReviewField;
const isC2RTransaction = (txn, txnAccount) => {
    const account = txnAccount !== null && txnAccount !== void 0 ? txnAccount : accounts_1.accountsSelectors.getAccountById(store_1.default === null || store_1.default === void 0 ? void 0 : store_1.default.getState(), txn.accountId);
    return !txn.isReviewed
        && (account === null || account === void 0 ? void 0 : account.isC2REnabled)
        && !(0, accountsUtils_1.isAccountDisconnected)(account)
        && getMatchState(txn) === 'downloaded'
        && txn.state !== 'PENDING';
};
exports.isC2RTransaction = isC2RTransaction;
